module.exports = __webpack_public_path__ + "static/GilroyAlt-Bold-9affc770ea21676d1cc4b9a234171bf5.eot";